import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="header">
      <div className="banner">
        <img src="/edbanner.png" alt="Evil District Tattoos Logo" className="banner-img" />
      </div>
      <div className="hamburger-menu" onClick={toggleMenu}>
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>
      <nav className={`side-menu ${menuOpen ? 'open' : ''}`}>
        <ul>
          <li>
            <Link to="/" onClick={toggleMenu}>Home</Link>
          </li>
          <li>
            <Link to="/portfolio" onClick={toggleMenu}>Portfolio</Link>
          </li>
          <li>
            <Link to="/contact" onClick={toggleMenu}>Contact Us</Link>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
